<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';
import HugeIcon from '../HugeIcon/HugeIcon.vue';

const BETA_TAG_ICON_SIZE = 16;
</script>

<template>
  <span
    class="border-primary-700 bg-primary-50 text-primary-700 inline-flex w-fit items-center gap-2 rounded-md border px-2 py-1 text-xs font-semibold tracking-wide uppercase"
  >
    <HugeIcon icon="beta" :size="BETA_TAG_ICON_SIZE" />
    {{ $t('generic_beta') }}
  </span>
</template>
